import React, { useState } from "react";
import ReactDOM from "react-dom";
import LoadingSpinner from "./LoadingSpinner";

const portalLoading = document.getElementById("loading");

const PortalLoading = ({isLoading,children}) => {
  return ReactDOM.createPortal(
    <>
      {
        isLoading &&
        <div className="box-loading">
          <LoadingSpinner isLoading={isLoading} children={""}></LoadingSpinner>
        </div>
      }
    </>
    , portalLoading);
};

export default PortalLoading;
